import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TabComponent} from './tab/tab.component';
import {TabContainerComponent} from './tab-container/tab-container.component';
import {SquareTabsComponent} from './square-tabs/square-tabs.component';
import {OpenTabsComponent} from './open-tabs/open-tabs.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [TabComponent, TabContainerComponent, SquareTabsComponent, OpenTabsComponent],
  exports: [TabComponent, TabContainerComponent, SquareTabsComponent, OpenTabsComponent],
})
export class TabsModule {
}
